import { render, staticRenderFns } from "./VariantSlider.vue?vue&type=template&id=03b38ad7&scoped=true&"
import script from "./VariantSlider.vue?vue&type=script&lang=js&"
export * from "./VariantSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b38ad7",
  null
  
)

export default component.exports